import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { InputAdornment, IconButton, Tooltip } from '@mui/material';
import { ContentPasteGo } from '@mui/icons-material';

/**
 * Hook for rendering an adornment in a text field with a button to pre-fill a default text.
 * @description The adornment is only shown while the field is empty.
 * @return A {@link InputAdornment} component, or undefined if nothing should be rendered.
 */
export const useInsertDefaultAdornment = (fieldName: string, defaultText: string): React.ReactNode => {
  const { t } = useTranslation();
  const formik = useFormikContext();
  let adornment: React.ReactNode;
  if (!formik.getFieldProps(fieldName).value) {
    const pasteDefault = () => {
      formik.setFieldValue(fieldName, defaultText);
    };
    adornment = (
      <InputAdornment position="end">
        <Tooltip title={t('dashboard.assets.addedit.insertDefaultText')}>
          <IconButton aria-label="insert default text" edge="end" onClick={pasteDefault}>
            <ContentPasteGo />
          </IconButton>
        </Tooltip>
      </InputAdornment>
    );
  }
  return adornment;
};
